var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import * as React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { getSellers, calculate, setRowDataByResults, setRowDataByPriceMode, getShippingResults } from '../actions/PriceExplorerGridAction';
import PricingGridLayoutV2 from './layout/PricingGridLayoutV2';
import PricingGridLayout from './layout/PricingGridLayout';
import ProductComparisonLayout from './layout/ProductComparisonLayout';
import { onShippingSubmit, saveShippingConfig, setSelectedTabConfiguration } from '../actions/PricingGridComponentAction';
import { loadPossibilitiesSet, setRuleSetInfo, initializeState } from '../actions/CustomBulkExportAction';
import { shapes } from '@cimpress/react-components';
import cloneDeep from 'lodash/cloneDeep';
var Spinner = shapes.Spinner; // eslint-disable-next-line react/prefer-stateless-function

var PriceExplorerGrid =
/** @class */
function (_super) {
  __extends(PriceExplorerGrid, _super);

  function PriceExplorerGrid() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loadInitialData = function () {
      _this.props.setRuleSetInfo().then(function () {
        _this.props.loadPossibilitiesSet().then(function () {
          _this.props.initializeState();
        });
      });

      _this.populatePricingGrid();
    };

    _this.populatePricingGrid = function () {
      var isSingleSkuEnvironment = _this.props.pricingGrid.isSingleSkuEnvironment;
      return _this.props.getSellers().then(function () {
        return _this.props.calculate(isSingleSkuEnvironment);
      });
    };

    _this.componentDidCatch = function (error, info) {
      if (_this.props.pricingGrid.logger) {
        _this.props.pricingGrid.logger.logError({
          message: 'Error occurred in PriceExplorerGrid Error Boundary',
          error: {
            errorInfo: error,
            info: info
          }
        }, 'pricingGrid');
      }
    };

    _this.onSelectedTabChange = function (selectedTab) {
      _this.props.setSelectedTabConfiguration(selectedTab);
    };

    return _this;
  }

  PriceExplorerGrid.prototype.componentDidMount = function () {
    this.loadInitialData();
  };

  PriceExplorerGrid.prototype.shouldComponentUpdate = function (nextProps) {
    return JSON.stringify(this.props.pricingGrid.skuData) !== JSON.stringify(nextProps.pricingGrid.skuData) || JSON.stringify(nextProps.priceExplorerGrid.rowData) !== JSON.stringify(this.props.priceExplorerGrid.rowData) || JSON.stringify(nextProps.priceExplorerGrid.headers) !== JSON.stringify(this.props.priceExplorerGrid.headers) || nextProps.pricingGrid.priceMode !== this.props.pricingGrid.priceMode || nextProps.pricingGrid.budgetRates !== this.props.pricingGrid.budgetRates || nextProps.pricingGrid.isSingleSkuEnvironment !== this.props.pricingGrid.isSingleSkuEnvironment || nextProps.pricingGrid.showCompetitivePricing !== this.props.pricingGrid.showCompetitivePricing || JSON.stringify(nextProps.pricingGrid.shippingConfiguration) !== JSON.stringify(this.props.pricingGrid.shippingConfiguration) || JSON.stringify(nextProps.pricingGrid.initialShippingConfiguration) !== JSON.stringify(this.props.pricingGrid.initialShippingConfiguration) || JSON.stringify(this.props.pricingGrid.productPriceContractsInfoV2) !== JSON.stringify(nextProps.pricingGrid.productPriceContractsInfoV2) || JSON.stringify(this.props.pricingGrid.productPriceContractsInfo) !== JSON.stringify(nextProps.pricingGrid.productPriceContractsInfo) || JSON.stringify(this.props.priceExplorerGrid.isLoadingEquivalencies) !== JSON.stringify(nextProps.priceExplorerGrid.isLoadingEquivalencies) || JSON.stringify(this.props.pricingGrid.grossMarginSelections) !== JSON.stringify(nextProps.pricingGrid.grossMarginSelections) || JSON.stringify(this.props.pricingGrid.selectedTab) !== JSON.stringify(nextProps.pricingGrid.selectedTab);
  };

  PriceExplorerGrid.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    if (!isEqual(Object.keys(prevProps.pricingGrid.skuData), Object.keys(this.props.pricingGrid.skuData))) {
      this.loadInitialData();
    } else if (JSON.stringify(prevProps.pricingGrid.skuData) !== JSON.stringify(this.props.pricingGrid.skuData) || prevProps.pricingGrid.isSingleSkuEnvironment !== this.props.pricingGrid.isSingleSkuEnvironment) {
      this.populatePricingGrid();
    } else if (!isEqual(prevProps.pricingGrid.shippingConfiguration, this.props.pricingGrid.shippingConfiguration)) {
      var rowData = this.props.priceExplorerGrid.rowData;
      this.props.setRowDataByResults(null);
      this.props.getShippingResults(rowData);
    } else if (!isEqual(prevProps.pricingGrid.priceMode, this.props.pricingGrid.priceMode) && this.props.priceExplorerGrid.rowData && this.props.priceExplorerGrid.rowData.length) {
      this.props.setRowDataByPriceMode(this.props.pricingGrid.priceMode);
    }
  };

  PriceExplorerGrid.prototype.render = function () {
    var _a;

    var _b = this.props.pricingGrid,
        isSingleSkuEnvironment = _b.isSingleSkuEnvironment,
        deliveryLocations = _b.deliveryLocations,
        isPivoting = _b.isPivoting,
        showToolBar = _b.showToolBar,
        toolBarIcons = _b.toolBarIcons,
        skuProductionTime = _b.skuProductionTime,
        priceMode = _b.priceMode,
        isSaveShippingEnabled = _b.isSaveShippingEnabled,
        shippingConfiguration = _b.shippingConfiguration,
        logger = _b.logger,
        showCompetitivePricing = _b.showCompetitivePricing,
        fulfillmentLocations = _b.fulfillmentLocations,
        skuData = _b.skuData,
        productPriceContractsInfo = _b.productPriceContractsInfo,
        selectedTab = _b.selectedTab,
        grossMarginSelections = _b.grossMarginSelections,
        showTabbedView = _b.showTabbedView;
    var _c = this.props.priceExplorerGrid,
        headers = _c.headers,
        rowData = _c.rowData,
        sellers = _c.sellers,
        contractsPerSku = _c.contractsPerSku,
        hasPermissionForFulfiller = _c.hasPermissionForFulfiller,
        isLoadingEquivalencies = _c.isLoadingEquivalencies,
        pricingVersion = _c.pricingVersion;
    var pricingResults = null;

    if (headers && rowData) {
      pricingResults = {
        headers: headers,
        rowData: rowData
      };
    }

    var selectedColumn;
    var sku;
    var showTabs;

    if (isSingleSkuEnvironment && skuData) {
      _a = __read(Object.keys(skuData), 1), sku = _a[0];

      if (skuData && skuData[sku]) {
        showTabs = !!hasPermissionForFulfiller[sku] && !!showTabbedView;
        selectedColumn = skuData[sku].selectedColumn;
      }
    }

    if (!isSingleSkuEnvironment) {
      showTabs = false;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars


    var pricingGridLayout = React.createElement("div", {
      style: {
        display: 'grid',
        placeItems: 'center'
      }
    }, React.createElement(Spinner, null));

    if (showTabs !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      pricingGridLayout = showTabs ? React.createElement(PricingGridLayoutV2, {
        results: pricingResults,
        priceMode: priceMode,
        deliveryLocations: deliveryLocations,
        fulfillmentLocations: fulfillmentLocations,
        productionTime: skuProductionTime && skuProductionTime.productionTime ? skuProductionTime.productionTime : null,
        isSaveShippingEnabled: isSaveShippingEnabled,
        saveShippingConfig: this.props.saveShippingConfig,
        onShippingSubmit: this.props.onShippingSubmit,
        shippingConfiguration: shippingConfiguration,
        isPivoting: isPivoting,
        showToolBar: showToolBar,
        toolBarIcons: toolBarIcons,
        logger: logger,
        showCompetitivePricing: showCompetitivePricing,
        contracts: contractsPerSku,
        sellers: sellers,
        productPriceContractsInfo: productPriceContractsInfo,
        grossMarginSelections: cloneDeep(grossMarginSelections),
        dualPivotMode: selectedColumn,
        isLoadingEquivalencies: isLoadingEquivalencies,
        selectedTab: selectedTab,
        onSelectedTabChange: this.onSelectedTabChange,
        saveTabInfo: this.props.pricingGrid.saveTabInfo,
        pricingVersion: pricingVersion
      }) : React.createElement(PricingGridLayout, {
        results: pricingResults,
        priceMode: priceMode,
        deliveryLocations: deliveryLocations,
        fulfillmentLocations: fulfillmentLocations,
        productionTime: skuProductionTime && skuProductionTime.productionTime ? skuProductionTime.productionTime : null,
        isSaveShippingEnabled: isSaveShippingEnabled,
        saveShippingConfig: this.props.saveShippingConfig,
        onShippingSubmit: this.props.onShippingSubmit,
        shippingConfiguration: shippingConfiguration,
        isPivoting: isPivoting,
        showToolBar: showToolBar,
        toolBarIcons: toolBarIcons,
        logger: logger,
        showCompetitivePricing: showCompetitivePricing,
        contracts: contractsPerSku,
        sellers: sellers,
        productPriceContractsInfo: productPriceContractsInfo,
        pricingVersion: pricingVersion
      });
    }

    return React.createElement("div", null, isSingleSkuEnvironment || showCompetitivePricing || Object.keys(skuData)[1] && Object.keys(skuData)[1] === 'competitorProducts' ? pricingGridLayout : // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    React.createElement(ProductComparisonLayout, {
      results: pricingResults,
      priceMode: priceMode,
      deliveryLocations: deliveryLocations,
      productionTime: skuProductionTime && skuProductionTime.productionTime ? skuProductionTime.productionTime : null,
      isSaveShippingEnabled: isSaveShippingEnabled,
      onShippingSubmit: this.props.onShippingSubmit,
      shippingConfiguration: shippingConfiguration,
      isPivoting: isPivoting,
      showToolBar: showToolBar,
      toolBarIcons: toolBarIcons,
      logger: logger
    }));
  };

  return PriceExplorerGrid;
}(React.Component);

function mapStateToProps(state) {
  return {
    customBulkExport: state.customBulkExport,
    pricingGrid: state.pricingGrid,
    priceExplorerGrid: state.priceExplorerGrid
  };
}

var mapDispatchToProps = {
  getSellers: getSellers,
  calculate: calculate,
  setRowDataByResults: setRowDataByResults,
  setRowDataByPriceMode: setRowDataByPriceMode,
  onShippingSubmit: onShippingSubmit,
  loadPossibilitiesSet: loadPossibilitiesSet,
  setRuleSetInfo: setRuleSetInfo,
  getShippingResults: getShippingResults,
  saveShippingConfig: saveShippingConfig,
  initializeState: initializeState,
  setSelectedTabConfiguration: setSelectedTabConfiguration
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(PriceExplorerGrid);